import { useCommand } from "../../../useAPI";
import * as uploadApi from "../../api";
import {
  Box,
  FeedbackBlock,
  unsafeLocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { useState } from "react";
import { option } from "fp-ts";
import * as classes from "../Photo/MobileIdUpload2.css";
import { useTestEnvironment } from "../../../Common/useTestEnvironment";
import { useZenid2, CameraError } from "../zenidUtils2";
import {
  IVerifier,
  SdkVerifierType,
  VerifierStateContainerForPublicDataBase,
  ZenidWebController,
  OnFrameProcessedCallback,
} from "@zenid/websdk";

export function SelfieTestPage() {
  type STATE = "Loading" | "Loaded" | "N/A" | "CameraError";
  const isTestEnv = useTestEnvironment();
  const [state, setState] = useState<STATE>(isTestEnv ? "Loading" : "N/A");
  const [cameraError, setCameraError] = useState("");

  switch (state) {
    case "CameraError":
      return (
        <FeedbackBlock
          size={"medium"}
          heading={unsafeLocalizedString("Error")}
          subheading={option.some(unsafeLocalizedString(cameraError))}
          type={"negative"}
          actions={[]}
        />
      );
    case "N/A":
      return null;
    case "Loading":
      return <InitFlow onLoaded={() => setState("Loaded")} />;
    case "Loaded":
      return (
        <ShowSelfie
          onCameraError={(e: any) => {
            setCameraError(e);
            setState("CameraError");
            console.log(e);
          }}
        />
      );
  }
}

type InitProps = {
  onLoaded: () => unknown;
};

function InitFlow(props: InitProps) {
  const startProcess = useCommand(uploadApi.startProcess);

  const { initialized } = useZenid2(
    startProcess,
    () => Promise.reject(),
    undefined,
    [SdkVerifierType.MsLiveness],
    true
  );

  if (initialized) {
    props.onLoaded();
  }

  return (
    <Box grow hAlignContent="center" vAlignContent="center">
      <FeedbackBlock
        type="loading"
        size="large"
        heading={unsafeLocalizedString("Loading")}
        subheading={option.none}
      />
    </Box>
  );
}

type SelfieProps = {
  onCameraError: (e: CameraError) => unknown;
};

function ShowSelfie(_: SelfieProps) {
  /*  const { feedbackText } = useCamera(
    useMemo(
      () => ({
        feature: "selfieVideo",
        cameraPreviewContainer: classes.cameraPreviewSelfieDemo,
        onError: props.onCameraError,
      }),
      []
    )
  );*/

  const onFrameProcessedCallback: OnFrameProcessedCallback = (
    state: VerifierStateContainerForPublicDataBase,
    verif: IVerifier
  ) => {
    console.log(">>> ", state, verif);
  };
  console.log(">>> ShowSelfie");
  ZenidWebController.Instance.loadAndRunVerifier(
    SdkVerifierType.MsLiveness,
    "{}",
    onFrameProcessedCallback
  );

  // console.log("feedbackText", feedbackText);

  /*  useSelfieSnapshot(classes.snapshotPreview, (snapshotData: SelfieData) => {
    const data = acquiredSelfie({
      blob: snapshotData.blob,
      signature: snapshotData.signature,
    });
    console.log(data);
  });*/

  return (
    <div data-zenid-camera-feed className={classes.cameraPreviewSelfieDemo} />
  );
}
